<template>
  <div>
    <h2>共 {{unsafeWordCount}} 個不安全的詞</h2>
    <template v-for="(element, index) in sentenceChunks">
      <SentenceChunk :key="element.word" :element="element" :index="index"></SentenceChunk>
    </template>
    <template v-if="debug">
      <h4>{{sentence}}</h4>
      <h2>{{splitSentence}}</h2>
      <h4>{{meanings}}</h4>
      <h2>{{sentenceChunks}}</h2>
    </template>
  </div>
</template>

<script>
import SentenceChunk from "@/components/SentenceChunk.vue";
import Global from "@/components/Global.vue";

export default {
  name: "SentenceMeaning",
  components: {
    SentenceChunk,
  },
  props: {
    sentence: String,
    meanings: Array,
  },
  data: function () {
    return {};
  },
  computed: {
    debug: function () {
      return Global.debug;
    },
    splitSentence: function () {
      let splitsentence = [this.sentence];
      this.meanings.forEach(function (meaning) {
        let newsplit = [];
        splitsentence.forEach(function (sentence) {
          let chunks = sentence.split(meaning.word);
          for (var i = 0; i < chunks.length; i++) {
            if (i == 0) {
              newsplit = newsplit.concat([chunks[i]]);
            } else {
              newsplit = newsplit.concat([meaning.word, chunks[i]]);
            }
          }
        });
        splitsentence = newsplit.slice(0);
      });
      return splitsentence;
    },
    sentenceChunks: function () {
      return this.splitSentence.map(function (sentence) {
        let element = sentence;
        this.meanings.forEach(function (meaning) {
          if (element === meaning.word) {
            if (!meaning.safe) {
              element = { type: "button", meaning: meaning };
            }
          }
        }, this);
        if (element === sentence) {
          element = { type: "text", meaning: { word: sentence } };
        }
        return element;
      }, this);
    },
    unsafeWordCount: function () {
      let count = 0;
      this.sentenceChunks.forEach((element) => {
        if (element.type === "button") count++;
      });
      return count;
    },
  },
};
</script>